core-progress-indicator {
  display: block;
}

.core-progress-indicator .progress-indicator-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--number-spacing-medium)
}

.core-progress-indicator .progress-indicator-header {
  display: flex;
  flex-direction: column;
}

.core-progress-indicator .progress-indicator-description {
  color: var(--color-neutral-content-medium);
}

.core-progress-indicator .progress-bar {
  display: flex;
  border-radius: var(--number-radius-round);
  width: 100%;
  overflow: hidden;
  background-color: var(--color-global-all-disabled-soft);
}

.core-progress-indicator .progress-bar--small {
  height: 0.25rem;
}

.core-progress-indicator .progress-bar--medium {
  height: 0.5rem;
}

.core-progress-indicator .progress-bar--large {
  height: 0.75rem;
}

.core-progress-indicator .progression-indicator {
  height: 100%;
  background-color: var(--color-brand-content);
  position: relative;
}

.core-progress-indicator .progress-indicator-label {
  color: var(--color-neutral-content-strong);
}

.core-progress-indicator .progress-bar-format--fractions {
  gap: var(--number-spacing-2xsmall);
  background-color: transparent;
}

.core-progress-indicator .progress-indicator-step {
  position: relative;
  border-radius: var(--number-radius-round);
  flex: 1;
  overflow: hidden;
  background-color: var(--color-global-all-disabled-soft);
}

.core-progress-indicator .progress-indicator-step--full::after {
  content: '';
  position: absolute;
  background-color: var(--color-brand-content);
  top: 0;
  bottom: 0;
  left: 0; 
  width: 100%;
}

.core-progress-indicator .progress-indicator-step--half::after {
  content: '';
  position: absolute;
  background-color: var(--color-brand-content);
  top: 0;
  bottom: 0;
  left: 0; 
  width: 50%;
}
